import React, { useEffect, useState, createElement } from 'react';
import { Hero } from './components/Hero';
import { Modules } from './components/Modules';
import { Testimonials } from './components/Testimonials';
import { Bio } from './components/Bio';
import { Footer } from './components/Footer';
import { RegistrationPopup } from './components/RegistrationPopup';
export function App() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);
  // GetResponse Analytics (web connect): carga el script de tracking una sola vez.
  useEffect(() => {
    const GR_TRACKING_SRC = 'https://an.gr-wcon.com/script/468e89f5-1489-4273-99c1-bbedbd4cac12/ga.js';
    if (document.querySelector(`script[src="${GR_TRACKING_SRC}"]`)) return;
    const e = 'GrTracking';
    const m = window as any;
    m['__GetResponseAnalyticsObject'] = e;
    m[e] = m[e] || function () {
      ;
      (m[e].q = m[e].q || []).push(arguments);
    };
    const r = document.createElement('script');
    r.async = true;
    r.src = GR_TRACKING_SRC;
    r.setAttribute('crossorigin', 'use-credentials');
    // Inserción segura: no dependemos de que exista un <script> previo.
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(r, firstScript);
    } else {
      ;
      (document.head || document.body || document.documentElement).appendChild(r);
    }
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-brand-orange selection:text-white" data-id="element-0">
      {/* Main Sections */}
      <main data-id="element-1">
        <Hero onOpenPopup={openPopup} data-id="element-2" />
        <Modules onOpenPopup={openPopup} data-id="element-3" />
        <Testimonials onOpenPopup={openPopup} data-id="element-4" />
        <Bio onOpenPopup={openPopup} data-id="element-5" />
      </main>

      {/* Footer */}
      <Footer data-id="element-6" />

      {/* Registration Modal con el formulario de GetResponse */}
      <RegistrationPopup isOpen={isPopupOpen} onClose={closePopup} data-id="element-7" />
    </div>;
}